@if (isHelp) {
  <div class="alert-container"
    style="overflow-y: auto; height:450px; background-color: lightblue;">
    <h1 mat-dialog-title style="margin-bottom: 30px;">{{data.title}}</h1>
    <div style="margin-bottom: 30px;">
      <span [innerHtml]="htmlContent"></span>
    </div>
    <div mat-dialog-actions>
      <button class="primary-btn-blue" mat-button mat-dialog-close
      (click)="closeDialog()">{{data.closeButtonText}}</button>
    </div>
  </div>
}

@if (isPassword||isDate) {
  <div class="alert-container">
    <h1 mat-dialog-title style="margin-bottom: 5px; font-weight: bold;">{{data.title}}</h1>
    <div mat-dialog-content >
      <span [innerHtml]="htmlContent"></span>
    </div>
    <div mat-dialog-actions>
      <button class="primary-btn-blue" mat-button mat-dialog-close
      (click)="closeDialog()">{{data.closeButtonText}}</button>
    </div>
  </div>
}

@if (isInActivate) {
  <div class="alert-container">
    <h1 mat-dialog-title style="margin-bottom: 5px; font-weight: bold;">{{data.title}}</h1>
    <br>
      <label class="alert-content">{{data.content}}</label>
      <br> <br>
      <div class="float-right">
        <button class="primary-btn-blue margin-right-16" mat-button mat-dialog-close
        (click)="closeDialog()">{{data.closeButtonText}}</button>
        <button class="primary-btn-blue" mat-button mat-dialog-close
        (click)="Inactivate()">Inactivate</button>
      </div>
    </div>
  }

  @if (isCeoApprovalWarning) {
    <div class="alert-container">
      <!-- <h1 mat-dialog-title style="margin-bottom: 5px; font-weight: bold;">{{data.title}}</h1> -->
      <div mat-dialog-content >
        <p class="dialog-message">
          <b>Attention: There is currently an active CEO account for this organization.</b>
        </p>
        <p class="dialog-message">
          Each organization can only have one CEO account active at a time. Please review and ensure the current CEO is the active account.
        </p>
        <p class="dialog-message">{{data.content}}</p>
        <p class="dialog-message">Thank You.</p>
      </div>
      <div mat-dialog-actions>
        <button class="primary-btn-blue" mat-button mat-dialog-close
        (click)="closeDialog()">{{data.closeButtonText}}</button>
      </div>
    </div>
  }
  @if (isNotifications) {
    <div class="user-notifications">
      <div mat-dialog-content >
        <table mat-table [dataSource]="dataSource" class="grid-style ">
          <!--  Message Count  -->
          <ng-container matColumnDef="Count">
            <th mat-header-cell *matHeaderCellDef>Count</th>
            <td mat-cell *matCellDef="let element">  <span>
              <a [routerLink]='element.url' (click)="closeDialog()"> {{element.count}} </a>
            </span>   </td>
          </ng-container>
          <!-- Message Type -->
          <ng-container matColumnDef="Type">
            <th mat-header-cell *matHeaderCellDef>Message</th>
            <td mat-cell *matCellDef="let element">{{element.message}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div mat-dialog-actions class="float-left">
        <button class="primary-btn-blue " mat-button mat-dialog-close
        (click)="closeDialog()">{{data.closeButtonText}}</button>
      </div>
    </div>
  }

  @if (isGeneral) {
    <div class="alert-container">
      <h4>{{data.title}}</h4>
      <label class="alert-content text-style">{{data.content}}</label>
      <br>
        <div class="dialog-btn-sec">
          <button class="primary-btn-blue" mat-button mat-dialog-close
          (click)="closeDialog()">{{data.closeButtonText}}</button>
        </div>
      </div>
    }

    <form [formGroup]="organizationFormGroup" >
      @if (isBulk) {
        <div class="bulk-user-registration alert-container">
          <h4>{{data.title}}</h4>
          <br>
            @if (isAdmin) {
              <div>
                <a download="LiveData.xls" class="mt-20" target="_blank" href="/assets/template/LiveData.xls"> Click here to download template  </a>
              </div>
            }
            @if (!isAdmin) {
              <div>
                @if (!displayMilitary && !displayNonMilitary && !displaySalvationArmy) {
                  <a style="color:red" (click)="onSubmit()">Click here to download template</a>
                }
                @if (displayMilitary) {
                  <a download="LiveData.xls" class="mt-20" target="_blank" href="/assets/template/Military.xls"> Click here to download template  </a>
                }
                @if (displayNonMilitary) {
                  <a download="LiveData.xls" class="mt-20" target="_blank" href="/assets/template/Non-Military.xls"> Click here to download template  </a>
                }
                @if (displaySalvationArmy) {
                  <a download="LiveData.xls" class="mt-20" target="_blank" href="/assets/template/SalvationArmy.xls"> Click here to download template  </a>
                }
              </div>
            }
            <br>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <mat-form-field class="w-100">
                    <mat-label>Organization Country</mat-label>
                    <mat-select panelClass="myPanelClass" placeholder="Please select Organization Country"
                      (selectionChange)="onSelectCountry($event.value)"
                      formControlName="country" required>
                      @for (country of sponsorCountryCollection; track country) {
                        <mat-option [value]="country.pkid">
                          {{country.name}}
                        </mat-option>
                      }
                    </mat-select>
                    <mat-error>
                      @if (!organizationFormGroup.get('country').valid ) {
                        <span>
                          Please select Country.
                        </span>
                      }
                    </mat-error>
                  </mat-form-field>
                </div>
                @if (isStateVisible) {
                  <div class="form-group col-md-6">
                    <mat-form-field appearance="fill" class="w-100">
                      <mat-label>Organization State</mat-label>
                      <mat-select panelClass="myPanelClass" placeholder="Please select Organization State"
                        (selectionChange)="onSelectState($event.value)"
                        formControlName="state" required>
                        @for (state of sponsorStateCollection; track state) {
                          <mat-option [value]="state.pkid">
                            {{state.name}}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        @if (!organizationFormGroup.get('state').valid ) {
                          <span>
                            Please select State.
                          </span>
                        }
                      </mat-error>
                    </mat-form-field>
                  </div>
                }
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Organization </mat-label>
                    <mat-select formControlName="organization"
                      (selectionChange)='changeOrganization($event.value)' [ngClass]="{ 'is-invalid':submitted &&  f.organization.errors }" required>
                      @for (organization of organizationsData; track organization) {
                        <mat-option
                          [value]="organization.organizationGlobalID">
                          {{organization.organizationName}}
                        </mat-option>
                      }
                    </mat-select>
                    <mat-error>
                      @if (!organizationFormGroup.get('organization').valid ) {
                        <span>
                          Please select Organization.
                        </span>
                      }
                    </mat-error>
                    @if (submitted && f.organization.errors) {
                      <div class="invalid-feedback">
                        @if (f.organization.errors.required) {
                          <div>Organization is required</div>
                        }
                      </div>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group col-md-6">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Site</mat-label>
                    <mat-select formControlName="site"
                      (selectionChange)='changeSite($event.value)'>
                      @for (site of sites; track site) {
                        <mat-option
                          [value]="site.id">
                          {{site.name}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="fileUpload float-left">
                <input id="uploadBtn" type="file" class="upload" (change)="handleFileInput($event)" />
              </div>
              <br><br><br>
              <div class="float-right">
                <button class="primary-btn-blue margin-right-16" mat-button mat-dialog-close
                  (click)="closeDialog()">
                  {{data.closeButtonText}}
                </button>
                <button class="primary-btn-blue" mat-button mat-dialog-close [disabled]="!isFileUploaded"
                  (click)="save()">
                  Save
                </button>
              </div>
            </div>
          }
        </form>
